import React from "react";
import { Helmet } from "react-helmet";

// Assets
import blogHeaderImage from "../../../assets/images/blog/blog-bump-1.jpg";
import blogAsset from "../../../assets/images/blog/blog-newModel-asset.jpg";


import "../blogTemplate.css";
import Footer from "../../Footer";

// Construct your blog data with an imported shareImage
const blogData = {
  title: "Introducing Bump-1.0 Model",
  description:
    "Introducing bump-1.0, an innovative AI model that transforms raw video content into actionable insights. Discover how its seamless integration and cutting-edge performance revolutionize video analysis for developers and businesses alike.",
  shareImage: blogHeaderImage,
};

function BlogHeader() {
  return (
    <div className="blog-header">
      <div className="blog-topic-pill">Announcements</div>

      <h1>{blogData.title}</h1>
      <p className="blog-info">April 19, 2025 • 5 min read</p>
    </div>
  );
}

function BlogBody() {
    return (
      <div className="blog-body">
        {/* Full-width share image */}
        <div className="blog-image-wrapper">
          <img
            src={blogData.shareImage}
            alt="Bumpups AI in Action"
            className="blog-picture"
          />
        </div>
  
        {/* Introductory Section */}
        <div className="body-content-block">
          <div className="blog-content-wrapper">
            <div className="blog-text">
              <p>
                Today, we’re excited to introduce <strong>bump-1.0</strong>—the innovative AI model that transforms <em>raw video content</em> into actionable insights. With <strong>bump-1.0</strong>, Bumpups is revolutionizing how businesses, developers, and content creators interact with video data.
              </p>
            </div>
          </div>
        </div>

        {/* Unleashing Video Intelligence Section */}
        <div className="body-content-block">
          <div className="blog-content-wrapper">
            <div className="blog-text">
              <p>
                <strong>bump-1.0</strong> harnesses advanced AI to analyze and contextualize video content with precision. By breaking down every frame and detail, our model converts complex video data into <em>structured, searchable insights</em>—empowering you to unlock hidden opportunities and drive innovation.
              </p>
            </div>
          </div>
        </div>
  
        {/* Seamless Integration & Unmatched Speed Section */}
        <div className="body-content-block">
          <div className="blog-content-wrapper">
            <div className="blog-section-title">
              <strong>Seamless Integration & Unmatched Speed</strong>
            </div>
            <div className="blog-text">
              <p>
                Engineered for efficiency, <strong>bump-1.0</strong> delivers rapid processing for interactive chat responses, precise timestamps, detailed descriptions, and more. This speed and reliability ensure smooth integration with your systems, letting you focus on building great products while we handle the <em>heavy lifting</em>.
              </p>
            </div>
          </div>
        </div>
  
        {/* Developer Ecosystem Section */}
        <div className="body-content-block">
          <div className="blog-content-wrapper">
            <div className="blog-section-title">
              <strong>A Thriving Developer Ecosystem</strong>
            </div>
            <div className="blog-text">
              <p>
                Bumpups is more than just an AI solution—it’s a community. Our extensive <a href="https://docs.bumpups.com/docs/getting-started" target="_blank" rel="noopener noreferrer">API documentation</a>, and strategic integrations (including our upcoming collaboration with <a href="https://zapier.com/apps/bumpups/integrations" target="_blank" rel="noopener noreferrer">Zapier</a>) are designed to empower developers at every level. Whether you're building internal tools or customer-facing applications, <strong>bump-1.0</strong> offers the flexibility and power you need.
              </p>
            </div>
          </div>
        </div>

        <div className="blog-image-wrapper">
        <img src={blogAsset} alt="Placeholder content" className="blog-picture" />
      </div>
  
        {/* Future Vision Section */}
        <div className="body-content-block">
          <div className="blog-content-wrapper">
            <div className="blog-section-title">
              <strong>A Glimpse into the Future</strong>
            </div>
            <div className="blog-text">
              <p>
                Currently, <strong>bump-1.0</strong> supports YouTube video analysis—with plans to extend support to platforms such as <em>Zoom</em> and <em>Facebook</em>. Our vision is to create an AI-driven future where every video, regardless of source, transforms into a strategic asset. Stay tuned as we roll out new features and integrations that will further redefine how video content is leveraged.
              </p>
            </div>
          </div>
        </div>
  
        {/* Commitment to Innovation & Safety Section */}
        <div className="body-content-block">
          <div className="blog-content-wrapper">
            <div className="blog-section-title">
              <strong>Commitment to Innovation & Safety</strong>
            </div>
            <div className="blog-text">
              <p>
                At Bumpups, innovation is at the heart of everything we do. We rigorously test and refine <strong>bump-1.0</strong> to ensure it meets the highest standards of performance and safety. Our commitment to secure, transparent, and ethical AI practices means you can trust our model to power your applications with reliability and integrity.
              </p>
            </div>
          </div>
        </div>
  
        {/* Call to Action Section */}
        <div className="body-content-block">
          <div className="blog-content-wrapper">
            <div className="blog-section-title">
              <strong>Get Started with bump-1.0 Today</strong>
            </div>
            <div className="blog-text">
              <p>
                Ready to elevate your video content analysis? Explore our comprehensive <a href="https://docs.bumpups.com/docs/getting-started" target="_blank" rel="noopener noreferrer">API documentation</a>, and join the community that’s shaping the future of video intelligence with <strong>bump-1.0</strong>.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  

function BlogFooter() {
  return (
    <div>
      <footer className="blog-footer">
        <hr className="blog-footer-line" />
      </footer>
    </div>
  );
}

function blogBumpModelLaunch() {
  return (
    <div className="blog-template">
      <Helmet>
        {/* Dynamic meta tags */}
        <title>{blogData.title} | Bumpups.com</title>
        <meta name="description" content={blogData.description} />

        {/* Open Graph meta tags for sharing */}
        <meta property="og:title" content={blogData.title} />
        <meta property="og:description" content={blogData.description} />
        <meta property="og:image" content={blogData.shareImage} />
        <meta property="og:url" content={window.location.href} />

        {/* Twitter Card meta tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blogData.title} />
        <meta name="twitter:description" content={blogData.description} />
        <meta name="twitter:image" content={blogData.shareImage} />
      </Helmet>
      <BlogHeader />
      <BlogBody />
      <BlogFooter />
      <Footer />
    </div>
  );
}

export default blogBumpModelLaunch;
